<!-- CXOne error message -->
<div class="license-error-container" *ngIf="noPMLicense">
    <svg class="error-icon">
        <use href="../App_Themes/CXone/images/no_permission_big.svg#no_permission_big"></use>
    </svg>

    <p class="cxone-error-text-title" cvLocalizedText langSection="Gamification_Admin_Messages" langKey="License_Required">
        License required
    </p>
    <p class="cxone-error-text">{{ getLocalizationMessageForLicense() }}</p>
</div>

<div class="error-container" *ngIf="!noPMLicense && noPermission">
    <svg class="error-icon">
        <use href="../App_Themes/CXone/images/no_permission_big.svg#no_permission_big"></use>
    </svg>

    <p class="cxone-error-text-title" cvLocalizedText langSection="Gamification_Admin_Messages" langKey="Permissions_Required">
        Permissions required
    </p>
    <p class="cxone-error-text">{{ getLocalizationMessageForPermissions() }}</p>
</div>